export enum ChatActionsEnum {
  OPEN = 'Open',
  CLOSE = 'Close',
  LAUNCH = 'Ask a question'
}
